module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_9006.8147d247.png";